<template>
  <v-container v-if="!review">
    <div class="text-h4">Do you need any new numbers?</div>
    <p>123NET will provide new numbers for you at your request.</p>
    <v-radio-group
      :value="getProductInfo().new_numbers_requested"
      @change="setNewNumbersRequested"
    >
      <v-radio value='y'>
        <template v-slot:label>
          <div>Yes, I do need new numbers</div>
        </template>
      </v-radio>

      <v-row v-if="getProductInfo().new_numbers_requested == 'y'" class="pa-6">
        <v-text-field
          label="How many new phone numbers?"
          :value="getProductInfo().quantity_numbers"
          @input="setQuantityNumbers"
        ></v-text-field>
      </v-row>

      <v-radio value='n'>
        <template v-slot:label>
          <div>No, I do not any new numbers from 123NET</div>
        </template>
      </v-radio>
    </v-radio-group>
  </v-container>
  <div v-else>
    <ReviewItem
      label="Do you need any new numbers?"
      :value="getProductInfo().new_numbers_requested === 'y' ? 'Yes' : 'No'"
    />
    <ReviewItem
      v-if="getProductInfo().new_numbers_requested === 'y'"
      label="How many new phone numbers?"
      :value="getProductInfo().quantity_numbers"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ReviewItem from '@/components/ReviewItem.vue';

export default {
  name: 'NewNumbers',
  props: {
    review: {
      required: false,
      type: Boolean,
    },
  },
  methods: {
    ...mapActions(['updateStoreFormData', 'updateNewNumbersField']),
    setNewNumbersRequested(newVal) {
      const vm = this;
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: 'new_numbers_requested',
      }).then(() => {
        vm.updateNewNumbersField();
      });
    },
    setQuantityNumbers(newVal) {
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: 'quantity_numbers',
      });
    },
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo']),
  },
  components: {
    ReviewItem,
  },
};
</script>
